<template>
  <div class="d-none d-md-block col-1">
    <div class="orange-column">
      <div class="social-container">
        <p><a href="https://www.facebook.com/profile.php?id=61557676063354" target="_blank"><img src="../assets/img/icon-fb.webp"></a></p>
        <br>
        <p><a href="https://api.whatsapp.com/send?phone=5213329039719&text=%C2%A1Hola!%20Me%20gustar%C3%ADa%20recibir%20informes." target="_blank"><img src="../assets/img/icon-wa.webp"></a></p>
        <br>
        <p><a href="https://www.instagram.com/" target="_blank"><img src="../assets/img/icon-ig.webp"></a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialBar'
}
</script>

